"use client";

import { useState } from "react";
import Icon from "@/components/ui/AppIcon";

interface FaqItem {
  question: string;
  answer: string;
}

interface FaqSection {
  title: string;
  icon: string;
  items: FaqItem[];
}

const faqData: FaqSection[] = [
  {
    title: "產品採購",
    icon: "CubeIcon",
    items: [
      {
        question: "你們供應哪些類型的電腦零件？",
        answer: "我們供應全面的電腦零件，包括 CPU（Intel 及 AMD）、GPU（NVIDIA 及 AMD）、主機板、記憶體（DDR4/DDR5）、儲存裝置（SSD/HDD）、電源供應器、散熱系統、機殼及電競周邊設備。我們的庫存涵蓋超過 500 個 SKU，來自各大知名品牌。",
      },
      {
        question: "你們可以採購目錄中沒有的特定產品嗎？",
        answer: "可以！我們專門提供客製化採購服務。如果您需要目前目錄中沒有的特定型號或品牌，請提供產品詳細資料與我們聯繫。我們將透過香港及台灣的供應商網絡，在 3-7 個工作天內為您採購難以找到的零件。",
      },
      {
        question: "你們的產品是正品且全新的嗎？",
        answer: "絕對是。我們只供應 100% 正品、原廠密封的產品，並附有原廠包裝。所有商品均附有序號及真偽驗證。我們與授權經銷商保持直接合作關係，以確保產品真實性。",
      },
    ],
  },
  {
    title: "訂購流程",
    icon: "ShoppingCartIcon",
    items: [
      {
        question: "如何下訂單？",
        answer: "請透過 WhatsApp（+852 5977 3386）或電郵（andy1oo5@pccargohk.com）聯繫我們，並提供您的產品清單及數量。我們將在 24 小時內提供詳細報價。確認後，我們將發送形式發票。付款可透過銀行轉帳或 PayPal 進行。收到付款確認後，訂單將立即處理。",
      },
      {
        question: "最低訂購量（MOQ）是多少？",
        answer: "標準產品沒有嚴格的最低訂購量限制，即使單件訂購也歡迎。但大量訂購（10 件以上或港幣 50,000 元以上）可享有 5-15% 的批量折扣，具體視產品類別及數量而定。",
      },
      {
        question: "報價需要多長時間？",
        answer: "標準目錄商品的報價將在 24 小時內提供。需要特殊定價談判的客製化採購或大量訂單，請預留 48-72 小時。如有緊急報價需求，請告知我們您的時間要求，我們將優先處理。",
      },
    ],
  },
  {
    title: "運送與交付",
    icon: "TruckIcon",
    items: [
      {
        question: "你們運送到哪些國家？",
        answer: "我們向全球 30 多個國家提供運送服務，涵蓋亞洲、歐洲、北美洲及大洋洲。主要市場包括香港、台灣、中國大陸、新加坡、馬來西亞、日本、南韓、美國、加拿大、英國及澳洲。請聯繫我們確認是否可運送至您的所在地。",
      },
      {
        question: "運費及交貨時間是多少？",
        answer: "運費視目的地、重量及服務等級而定。香港本地送貨：港幣 50-150 元（1-2 天）。亞洲地區：25-80 美元（3-7 天）。國際運送：40-150 美元（5-14 天）。我們使用 DHL、FedEx 及順豐速運。確切費用將在報價中計算。香港境內訂單超過港幣 30,000 元可享免費送貨。",
      },
      {
        question: "你們提供追蹤資訊嗎？",
        answer: "是的，所有貨件均提供完整追蹤服務。貨件發出後，您將透過電郵及 WhatsApp 收到追蹤號碼。您可透過快遞公司網站即時追蹤包裹狀態。我們也會主動更新重要里程碑（發貨、清關、即將送達）。",
      },
    ],
  },
  {
    title: "保固與退貨",
    icon: "ShieldCheckIcon",
    items: [
      {
        question: "你們提供什麼保固？",
        answer: "所有產品均附有原廠保固（通常為 1-3 年，視零件而定）。我們作為保固聯絡窗口，如有問題，我們將代表您直接與製造商協調處理。此外，我們提供 7 天 DOA（到貨即損壞）更換保證，適用於有缺陷的商品。",
      },
      {
        question: "你們的退貨政策是什麼？",
        answer: "未開封、未使用且保留原廠包裝的商品，可在收貨後 7 天內申請退貨，並收取 15% 的補貨費用。對於有缺陷的產品（DOA），我們提供免費退貨運送及全額更換或退款。如收到損壞或錯誤商品，請立即聯繫我們，我們將在 48 小時內解決。",
      },
      {
        question: "如何申請保固服務？",
        answer: "請提供您的訂單號碼、產品詳情及問題描述與我們聯繫，如有可能請附上照片或影片。我們將評估申請並引導您完成 RMA 流程。香港本地客戶可親自送至我們的觀塘辦公室。國際客戶將收到預付退貨標籤用於保固申請。",
      },
    ],
  },
  {
    title: "大量訂購查詢",
    icon: "BuildingOfficeIcon",
    items: [
      {
        question: "大量訂購有特別價格嗎？",
        answer: "有！我們提供分級批量折扣：10-49 件（95 折）、50-99 件（92 折）、100-499 件（88 折）、500 件以上（85 折及客製化議價）。折扣按產品線計算。訂單超過港幣 500,000 元，我們提供專屬定價方案，根據您的業務需求量身訂製。",
      },
      {
        question: "你們可以處理企業或經銷商帳戶嗎？",
        answer: "當然可以。我們與系統整合商、零售商、電商賣家及企業 IT 部門合作，遍及 30 多個國家。我們為合資格帳戶提供 NET 30/60 付款條款、專屬客戶經理、優先庫存分配及客製化物流解決方案。請電郵您的公司註冊文件申請企業帳戶。",
      },
      {
        question: "你們提供 OEM/ODM 服務嗎？",
        answer: "對於大型項目（1000 件以上），我們可透過台灣及中國大陸的製造合作夥伴安排 OEM/ODM 服務。服務包括客製化品牌、包裝設計、預裝服務及品質控制檢驗。交貨期通常為 45-90 天。請聯繫我們討論您的項目需求。",
      },
    ],
  },
  {
    title: "付款條款",
    icon: "CreditCardIcon",
    items: [
      {
        question: "你們接受哪些付款方式？",
        answer: "我們接受多種付款方式以配合國際 B2B 交易：電匯（T/T Wire Transfer）、信用狀（L/C）、PayPal 及銀行轉帳。對於已建立合作關係的企業帳戶，我們亦提供 NET 30/60 付款條款。請聯繫我們討論最適合您業務的付款方式。",
      },
      {
        question: "電匯付款如何操作？",
        answer: "電匯（T/T）是我們 B2B 訂單最常用的付款方式。訂單確認後，我們將發出附有香港銀行帳戶資料的形式發票。付款通常需在 3-5 個工作天內完成。收到款項後訂單將立即處理。大型客製化訂單可能需要預付 30% 訂金，餘款於出貨前結清。",
      },
      {
        question: "你們接受信用狀（L/C）付款嗎？",
        answer: "是的，我們接受不可撤銷信用狀，適用於超過 10,000 美元的訂單。信用狀須由信譽良好的銀行開立，並由我們的香港銀行確認。標準信用狀條款：即期信用狀或 30/60 天遠期信用狀。申請信用狀前，請先聯繫我們了解完整的信用狀要求及銀行資料。",
      },
      {
        question: "可以用 PayPal 付款嗎？",
        answer: "是的，PayPal 適用於 5,000 美元以下的訂單。請注意，PayPal 付款將收取 3.5% 的手續費，並計入發票總額。PayPal 非常適合小額訂單或希望享有買家保障的新客戶。付款必須以「商品與服務」方式發送，不可使用「親友轉帳」。請聯繫我們獲取 PayPal 帳戶資料。",
      },
      {
        question: "付款有安全保障嗎？",
        answer: "絕對有。所有交易均附有正式發票及收據完整記錄。對於新客戶，我們建議從較小的訂單開始建立信任。我們將在收到款項後 24 小時內確認付款。我們的香港公司已完成公司註冊，完全符合本地商業法規，確保您的付款安全且可追溯。",
      },
      {
        question: "你們接受哪些貨幣？",
        answer: "我們主要以港幣（HKD）、美元（USD）及新台幣（TWD）進行交易。電匯方面，國際訂單優先使用美元。發票可根據您的需求以港幣或美元開立。貨幣匯率以發票開立時為準。",
      },
    ],
  },
];

export default function FaqContent() {
  const [openItems, setOpenItems] = useState<{ [key: string]: boolean }>({});

  const toggleItem = (sectionIndex: number, itemIndex: number) => {
    const key = `${sectionIndex}-${itemIndex}`;
    setOpenItems((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6 md:px-10">
        {faqData.map((section, sectionIndex) => (
          <div key={sectionIndex} className="mb-16 last:mb-0">
            {/* Section Header */}
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 rounded-2xl bg-orange/10 flex items-center justify-center">
                <Icon name={section.icon} size={24} className="text-orange" />
              </div>
              <div>
                <h2 className="font-heading font-black text-2xl md:text-3xl text-navy">
                  {section.title}
                </h2>
              </div>
            </div>

            {/* FAQ Items */}
            <div className="space-y-4">
              {section.items.map((item, itemIndex) => {
                const key = `${sectionIndex}-${itemIndex}`;
                const isOpen = openItems[key];

                return (
                  <div
                    key={itemIndex}
                    className="border border-navy-100/40 rounded-2xl overflow-hidden transition-all duration-300 hover:border-orange/40 hover:shadow-navy-sm"
                  >
                    <button
                      onClick={() => toggleItem(sectionIndex, itemIndex)}
                      className="w-full px-6 py-5 flex items-start justify-between gap-4 text-left bg-white hover:bg-bg-light/50 transition-colors duration-200"
                    >
                      <div className="flex-1">
                        <h3 className="font-heading font-bold text-lg text-navy">
                          {item.question}
                        </h3>
                      </div>
                      <div
                        className={`flex-shrink-0 w-8 h-8 rounded-full bg-orange/10 flex items-center justify-center transition-transform duration-300 ${
                          isOpen ? "rotate-180" : ""
                        }`}
                      >
                        <Icon name="ChevronDownIcon" size={20} className="text-orange" />
                      </div>
                    </button>

                    {/* Answer */}
                    <div
                      className={`overflow-hidden transition-all duration-300 ${
                        isOpen ? "max-h-96" : "max-h-0"
                      }`}
                    >
                      <div className="px-6 pb-5 pt-2 bg-bg-light/30">
                        <p className="text-text-mid leading-relaxed">{item.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}

        {/* Contact CTA */}
        <div className="mt-16 p-8 rounded-3xl bg-gradient-to-br from-navy to-navy-light text-center">
          <h3 className="font-heading font-black text-2xl text-white mb-3">
            仍有疑問？
          </h3>
          <p className="text-white/70 mb-6 max-w-xl mx-auto">
            我們的團隊隨時為您提供協助。請透過 WhatsApp 或電郵聯繫我們，獲取專屬解答。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://wa.me/85259773386"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-orange hover:bg-orange-dark text-white px-6 py-3 rounded-full font-bold transition-all duration-200 shadow-orange-glow hover:shadow-none"
            >
              <Icon name="ChatBubbleLeftRightIcon" size={20} variant="solid" />
              WhatsApp 聯繫我們
            </a>
            <a
              href="mailto:andy1oo5@pccargohk.com"
              className="flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-full font-bold transition-all duration-200 border border-white/30"
            >
              <Icon name="EnvelopeIcon" size={20} />
              電郵聯繫我們
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}